import { ArticleHeading3 } from '@cian/ui-kit';
import * as style from './Points.css';
import { clsx } from 'clsx';
import { POINTS } from 'shared/constants/points';
import { TPoints } from 'shared/types/points';

interface IPointsProps {
  activePoint: TPoints;
  onActivePoint: (value: TPoints) => void;
}

export const Points: React.FC<IPointsProps> = ({ activePoint, onActivePoint }) => {
  return (
    <div className={style['container']}>
      <div className={style['line']}>
        {POINTS.slice(0, 3).map(item => (
          <div
            key={item.id}
            onClick={() => onActivePoint(item)}
            className={clsx(style['item'], item.id === activePoint.id && style['active'])}
          >
            {item.title}
          </div>
        ))}
      </div>
      <div className={style['answer-container']}>
        <div className={style['answer']} key={activePoint.description}>
          <ArticleHeading3 fontWeight="400">{activePoint.description}</ArticleHeading3>
        </div>
        <div className={clsx(style['line'], style['line-end'])}>
          {POINTS.slice(3).map(item => (
            <div
              key={item.id}
              onClick={() => onActivePoint(item)}
              className={clsx(style['item'], item.id === activePoint.id && style['active'])}
            >
              {item.title}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
